import { render, staticRenderFns } from "./PricelistItemDetail.vue?vue&type=template&id=7c75d8e0&scoped=true"
import script from "./PricelistItemDetail.vue?vue&type=script&lang=js"
export * from "./PricelistItemDetail.vue?vue&type=script&lang=js"
import style0 from "./PricelistItemDetail.vue?vue&type=style&index=0&id=7c75d8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c75d8e0",
  null
  
)

export default component.exports